import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { AuthService } from "@auth0/auth0-angular";
import { combineLatest, filter, map, take } from "rxjs";

// This guard is meant to protect pages that only anonymous users can get to
// Likely will only ever be used to guard the login page (i.e. an authenticated user shouldn't be able to get to the login page)

export const anonymousGuard: CanActivateFn = () => {
    const auth = inject(AuthService);
    const router = inject(Router);

    return combineLatest([auth.isLoading$, auth.isAuthenticated$]).pipe(
        filter(([loading]) => !loading),
        take(1),
        map(([_, isAuthenticated]) => {
            if (isAuthenticated) {
                router.navigate(["/home"]);
                return false;
            }
            return true;
        })
    );
};
